import React from 'react'
import './Form.scss'

const Form = () => {
  return (
    <div>Form</div>
  )
}

export default Form